import darkTheme from './github-dark.json';
import lightTheme from './github-light.json';
export * from './Editor';
export { darkTheme, lightTheme };
